module.exports = __webpack_public_path__ + "assets/images/premium-features/googlecal-0f50c7.png";